export default __webpack_public_path__ + "static/media/icon-media-library.4d109e65.svg";